export const formatParams = (parameters) => {
  let params = parameters.split('?')[1];
  if (typeof params !== 'undefined') {
    params = JSON.parse(
      '{"' +
        decodeURI(params)
          .replace(/"/g, '\\"')
          .replace(/&/g, '","')
          .replace(/=/g, '":"') +
        '"}'
    );
  } else {
    params = null;
  }
  return params;
};
